import { PageClasses } from '../page/PageClasses';

export const CarouselClasses = {
  tweenOne: { component: 'div', ...PageClasses.block },
  tweenOne1: { gutter: [8, 8], justify: PageClasses.justifyCenter },
  row: { justify: PageClasses.justifyCenter, gutter: [8, 8] },
  row1: { justify: PageClasses.justifyStart, gutter: [8, 8] },
  block: { ...PageClasses.block },
};
